import { Dialog, DialogStore, useDialogStore } from "@ariakit/react";
import { useCallback } from "react";
import { Link } from "wouter";
import * as css from "./style.css";

function MenuIcon() {
  return (
    <svg
      width="40px"
      height="40px"
      viewBox="0 0 40 40"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Menu</title>

      <g stroke="inherit" strokeWidth="1" fill="inherit">
        <path d="M5.2317038,27.5 L37.2007286,27.5 L34.7682962,32.5 L2.79927137,32.5 L5.2317038,27.5 Z M37.2007286,17.5 L34.7682962,22.5 L2.79927137,22.5 L5.2317038,17.5 L37.2007286,17.5 Z M5.2317038,7.5 L37.2007286,7.5 L34.7682962,12.5 L2.79927137,12.5 L5.2317038,7.5 Z" />
      </g>
    </svg>
  );
}

import { ExternalLink } from "@indietabletop/appkit/external-link";
import { LinkButton } from "../dialog-buttons";
import { Icon } from "../icon";
import { links } from "../links";
import { navItems } from "../nav-items";
import { useRulesets } from "../ruleset-provider/context";
import * as sidebar from "./sidebar.css";

function Sidebar(props: { store: DialogStore }) {
  const rulesets = useRulesets();

  const closeSidebar = useCallback(() => {
    props.store.hide();
  }, [props.store]);

  return (
    <Dialog modal={false} store={props.store} className={sidebar.sidebar}>
      <nav className={sidebar.links}>
        {navItems.map((item) => {
          return (
            <Link
              key={item.href}
              onClick={closeSidebar}
              href={item.href}
              className={sidebar.link}
            >
              <div>
                <h2 className={sidebar.heading}>{item.heading}</h2>
                <p className={sidebar.sidebarDescription}>{item.description}</p>
              </div>

              <Icon name="forward" />
            </Link>
          );
        })}
      </nav>

      <footer className={sidebar.footer}>
        <div className={sidebar.footerInfo}>
          <div>Ruleset v{rulesets.latest.version}</div>

          <div>
            <ExternalLink className={sidebar.footerLink} href={links.discord}>
              Discord
            </ExternalLink>
            <span className={sidebar.middot}> · </span>
            <ExternalLink className={sidebar.footerLink} href={links.roadmap}>
              Roadmap
            </ExternalLink>
          </div>
        </div>

        <LinkButton href={links.eternol} sticky={false} textAlign="center">
          Get the rules
        </LinkButton>
      </footer>
    </Dialog>
  );
}

export function Spine() {
  const dialog = useDialogStore();

  return (
    <>
      <Sidebar store={dialog} />

      <nav className={css.spine}>
        <button
          type="button"
          onClick={dialog.toggle}
          className={css.menuButton}
        >
          <MenuIcon />
        </button>

        <Link href="~/" className={css.text}>
          <div className={css.title}>Eternøl</div>
          <div className={css.authors}>
            by Kye Browning & Dellon Myette, with Till Förster
          </div>
        </Link>
      </nav>
    </>
  );
}
